import { STATIC_COMMON_FIELDS } from '../transforms/common';
import { STATIC_FIELDS } from '../transforms/markets/common';
import { hasProperty, isGuid } from '../../util/jquery';

const _securityDetailsCache = new Map();
const _staticFieldsMap = new Map();
Object.keys(STATIC_FIELDS).forEach(key => {
    _staticFieldsMap.set(STATIC_FIELDS[key], key);
});

export default class SecurityDetails {
    constructor(options) {
        this.securityManager = options.securityManager;
        this.apiManager = options.apiManager;
        this.dataPoint = Object.keys(STATIC_COMMON_FIELDS);
    }
    async securityDetails(params) {
        const {
            staticQueryList,
            securityMap,
            idQueryList
        } = await this._queryIdService(params);
        let fields = [];
        if (securityMap.size > 0) {
            let data = [];
            // query static data service
            if (staticQueryList.length > 0) {
                const securities = staticQueryList.map(item => item.queryKey);
                staticQueryList.forEach(item => {
                    if (item.fields) {
                        fields = [...fields, ...item.fields];
                    }
                });
                fields = Array.from(new Set(fields))
                    .map(f => _staticFieldsMap.get(f))
                    .filter(item => item);
                // For the two points of pm032 and st299, secType judgment is required
                const target = fields.find(
                    dp => dp === 'PM032' || dp === 'ST299'
                );
                if (target) {
                    fields = Array.from(
                        new Set([...fields, ...['PM032', 'ST299', 'SECTYPE']])
                    );
                }
                data = await this.apiManager
                    .getMarketSecurityDetails(
                        securities,
                        this.dataPoint,
                        fields,
                        params.method,
                        params.timeout
                    )
                    .catch(e => {
                        if (
                            params.securities.length === staticQueryList.length
                        ) {
                            throw e;
                        }
                    });
            }
            return this._staticTransforms(params.securities, securityMap, data);
        } else {
            throw this.securityManager.getInvalidSecuritiesError(idQueryList);
        }
    }

    async _queryIdService(params) {
        const idQueryList = [];
        const securityMap = new Map();
        let staticQueryList = [];
        params.securities.forEach(security => {
            if ((security !== '|' && /\|/.test(security)) || isGuid(security)) {
                securityMap.set(security, security);
                staticQueryList.push(
                    this.getSecurityDetailsParameters(security, params.fields)
                );
            } else {
                idQueryList.push(security);
            }
        });
        // query id service for those securities don't contains secId and instruments
        if (idQueryList.length > 0) {
            const securities = await this.securityManager.create(idQueryList);
            securities.forEach(security => {
                if (security.isValid()) {
                    const staticQuery = `${security.securityId}|${security.quoteInstrument}`;
                    securityMap.set(security.queryKey, staticQuery);
                    staticQueryList.push(
                        this.getSecurityDetailsParameters(
                            staticQuery,
                            params.fields
                        )
                    );
                }
            });
            staticQueryList = staticQueryList.filter(item => !!item);
        }
        return {
            idQueryList,
            securityMap,
            staticQueryList
        };
    }
    getSecurityDetailsParameters(queryKey, fields = []) {
        const cacheData = _securityDetailsCache.get(queryKey);
        let noCacheFields = [];
        if (!cacheData) {
            return {
                queryKey,
                fields
            };
        } else {
            if (fields.length === 0) {
                return { queryKey };
            } else {
                fields.forEach(field => {
                    if (
                        _staticFieldsMap.get(field) &&
                        !hasProperty(cacheData.statics, field)
                    ) {
                        noCacheFields.push(field);
                    }
                });
                if (noCacheFields.length > 0) {
                    return { fields: noCacheFields, queryKey };
                } else {
                    return null;
                }
            }
        }
    }

    _staticTransforms(securities, securityMap, marketStatic = []) {
        // queryKey :  [FOUSA06Z1E, 126.1.IBM]
        return securities.map(queryKey => {
            const inputKey = securityMap.get(queryKey); // FOUSA06Z1E|21.8.JSOSX
            if (!inputKey) {
                return {
                    security: queryKey,
                    statics: []
                };
            }
            let cacheData = _securityDetailsCache.get(inputKey);
            if (!cacheData) {
                const security =
                    this.securityManager.getSecurities([queryKey])[0] || {};
                cacheData = {
                    security: queryKey,
                    statics: {
                        instrument: security.instrument,
                        quoteInstrument: security.quoteInstrument,
                        securityId: security.securityId,
                        mstarType: security.mstarType
                    }
                };
            }
            let targetStatics = marketStatic.filter(
                item => item.inputKey === inputKey
            );
            if (targetStatics.length) {
                targetStatics = targetStatics[0].statics;
            }
            targetStatics.forEach(f => {
                cacheData.statics[f.name] = f.value;
            });
            _securityDetailsCache.set(inputKey, cacheData);
            const staticsData = Object.keys(cacheData.statics).map(item => {
                return { name: item, value: cacheData.statics[item] };
            });
            return {
                security: queryKey,
                statics: staticsData
            };
        });
    }
}
